// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithRedirect, signOut } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDy6jzY3v-U4zVNjB6kYPNxnWw0J9VwlEQ",
  authDomain: "checkitout-cfba5.firebaseapp.com",
  projectId: "checkitout-cfba5",
  storageBucket: "checkitout-cfba5.firebasestorage.app",
  messagingSenderId: "217563535042",
  appId: "1:217563535042:web:2b120b53cd5a561c3a4d5b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Add additional scopes and custom parameters
provider.addScope('email');
provider.addScope('profile');
provider.setCustomParameters({
  prompt: 'select_account'
});

// Export the auth functions and objects
export { auth, provider, signInWithPopup, signInWithRedirect, signOut };